<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('pharmacy-groups::page.title.pharmacy_groups') }}</h2>
            <pharmacy-groups-data-table :list-route="listRoute"></pharmacy-groups-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
};
</script>
